import { models } from 'powerbi-client';
import { useSelector } from "react-redux"
import { RootState } from "../store/store";
import { isMobile, useMobileOrientation } from 'react-device-detect';


export const usePowerbiInfo = () =>{
  const data = useSelector((state:RootState) => state.report);

  const { isLandscape } = useMobileOrientation();
  let hasMobileLayout: boolean = true;
  let showFilter: boolean = false;
  let hasAdditionalDataset = false;
  
  if (data.report?.config) {
    if (data.report.config.hasMobileLayout)
      hasMobileLayout = data.report.config.hasMobileLayout;
    if (data.report.config.showFilter)
      showFilter = data.report.config.showFilter;
    
    if (data.report.config.datasetId)
      hasAdditionalDataset = true;
  }


  let info: models.IReportEmbedConfiguration = {
    type: 'report',   // Supported types: report, dashboard, tile, visual and qna
    id: data.report.id,
    embedUrl: data.report.embedUrl,
    accessToken: data.report.accessToken,
    tokenType: models.TokenType.Embed,
    settings: {
      background: models.BackgroundType.Default,
      navContentPaneEnabled: data.report.config?.showTab,
      panes: {
        filters: {
          expanded: true,
          visible: showFilter,
        },
      },
    }
  }

  if (isMobile && hasMobileLayout && info && info.settings) {
    if (isLandscape) {
      info.settings.layoutType = models.LayoutType.MobileLandscape;
    } else {
      info.settings.layoutType = models.LayoutType.MobilePortrait;
    }
  }
  
  if (hasAdditionalDataset) {
    info.datasetBinding = {
      datasetId: data.report.config.datasetId
    };
  }

  return info;
}